export const NUM_PLAYERS_CHANGED = 'NUM_PLAYERS_CHANGED'

export const numPlayersChanged = ({ onlinePlayers, numPlayers }) => {
    return { type: NUM_PLAYERS_CHANGED, onlinePlayers, numPlayers }
}


// WEBPACK FOOTER //
// ./src/reducers/numPlayers/actions.js